// © Sitecore Corporation A/S. All rights reserved. Sitecore® is a registered trademark of Sitecore Corporation A/S.
/**
 * Values for the [sameSite] cookie property
 */
var SameSiteProperties;
(function (SameSiteProperties) {
    SameSiteProperties["Strict"] = "Strict";
    SameSiteProperties["Lax"] = "Lax";
    SameSiteProperties["None"] = "None";
})(SameSiteProperties || (SameSiteProperties = {}));

export { SameSiteProperties };
